__turbopack_context__.v({
  "icon": "PrimaryNavSearchIconButton-module__zNGN4q__icon",
  "iconWrapper": "PrimaryNavSearchIconButton-module__zNGN4q__iconWrapper",
  "trigger": "PrimaryNavSearchIconButton-module__zNGN4q__trigger",
});
